import store from '@/store'

export default {
  onEdit (to, from, next) {
    let promises = []
    promises.push(store.dispatch('periods/get', to.params))
    next(Promise.all(promises))
  }
}



// WEBPACK FOOTER //
// ./src/guards/periods.guards.js